module.exports = __webpack_public_path__ + "img/59.ee1bb95d.png";